// Brand tokens shared with the mobile app (src/constants/colors.ts)
export const Colors = {
  background: "#F8FAFC",
  white: "#FFFFFF",
  primary: "#2563EB",
  primaryDark: "#1D4ED8",
  primaryLight: "#EFF6FF",
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  textMuted: "#94A3B8",
  border: "#E2E8F0",
  borderLight: "#F1F5F9",
  success: "#059669",
  successLight: "#ECFDF5",
  warning: "#D97706",
  warningLight: "#FFFBEB",
  error: "#DC2626",
  errorLight: "#FEF2F2",
  structure: "#2563EB",
  electrical: "#D97706",
  mechanic: "#059669",
  finishing: "#7C3AED",
};

export const CategoryColors = {
  structure: Colors.structure,
  electrical: Colors.electrical,
  mechanic: Colors.mechanic,
  finishing: Colors.finishing,
  super_admin: Colors.primary,
};

export const CategoryLabels = {
  structure: "Structure",
  electrical: "Electrical",
  mechanic: "Mechanic",
  finishing: "Finishing",
};

// Soft background tint for a category accent.
export const tint = (hex, alpha = "15") => `${hex}${alpha}`;
